// src/features/messages/filterConversations.ts — pure conversation-list filter.
import type { Conversation } from '@/core/models/message';
import type { ConvoFilter } from './meta';

export interface ConvoQuery {
  filter: ConvoFilter;
  search: string;
}

/**
 * Pure: filter conversations by tab + name search. Preserves order; never
 * mutates input.
 *
 * 1.24.00: a `pending` thread (a message request awaiting MY acceptance) shows
 * ONLY under the `requests` tab. Letting one leak into All/Unread would put a
 * stranger's message in the inbox, which is the exact thing message requests
 * exist to prevent.
 */
export function filterConversations(convos: Conversation[], q: ConvoQuery): Conversation[] {
  const search = q.search.trim().toLowerCase();
  return convos.filter((c) => {
    const isRequest = c.pending === true;
    if (q.filter === 'requests') {
      if (!isRequest) return false;
    } else if (isRequest) {
      return false;
    }
    if (q.filter === 'unread' && c.unread <= 0) return false;
    if (q.filter === 'group' && c.type !== 'group') return false;
    if (search !== '' && !c.name.toLowerCase().includes(search)) return false;
    return true;
  });
}
